import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import PackageCard from '../components/PackageCard';
import SuccessStories from '../components/SuccessStories';
import TrustBadges from '../components/TrustBadges';
import LearnToDriveWithUs from '../components/LearnToDriveWithUs';
import BeforeYouBook from '../components/BeforeYouBook';
import { ArrowRight, Check } from 'lucide-react';
const HomePage = () => {
  // Featured packages for homepage
  const standardPackages = [{
    title: '2 Hour Package',
    price: '£76',
    originalPrice: '£80',
    description: '£38 per hour - Automatic lessons for beginners or refresher sessions.',
    features: ['Save £4 on standard pricing', 'Behind-the-wheel training', 'Traffic rules and regulations'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '10 Hour Package',
    price: '£370',
    originalPrice: '£400',
    description: '£37 per hour - Popular standard package for automatic lessons.',
    features: ['Save £30 on standard pricing', 'Complete driving skills coverage', 'Junction and roundabout mastery'],
    popular: true,
    saving: '£30',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '20 Hour Package',
    price: '£710',
    originalPrice: '£800',
    description: '£35.50 per hour - Full training for complete beginners.',
    features: ['Save £90 on standard pricing', 'Full driving skills coverage', 'Test preparation'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  const intensivePackages = [{
    title: '20 Hour Intensive',
    price: '£910',
    originalPrice: '£1000',
    description: '£45.50 per hour - Accelerated training for test-ready drivers.',
    features: ['Save £90 on standard pricing', 'Accelerated learning', 'Ideal for quick test preparation'],
    saving: '£90',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '34 Hour Intensive',
    price: '£1,496',
    originalPrice: '£1,700',
    description: '£44 per hour - Our most complete package for beginners.',
    features: ['Save £204 on standard pricing', 'Complete driver training', 'Fast-track to test readiness'],
    popular: true,
    saving: '£204',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  const additionalPackages = [{
    title: 'Refresher Lessons',
    price: '£90',
    description: '£45 per hour - Rebuild your confidence on the road.',
    features: ['2 hours of focused training', 'Experienced instructors', 'Personalised to your needs'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Motorway Lessons',
    price: '£90',
    description: '£45 per hour - Gain confidence on high-speed roads.',
    features: ['2 hours of motorway practice', 'Safe environment to learn', 'Essential skills for all drivers'],
    popular: true,
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-gray-50" data-id="element-1326" data-mp="o8sy1zaei4bw">
      <Helmet data-id="element-1327" data-mp="o7ret7j8ebj3">
        <title data-id="element-1328" data-mp="o66ueaqms8yy">
          Automatic Driving Lessons in Northampton | ⭐⭐⭐⭐⭐ Rated by
          Students| Northampton Driving School
        </title>
        <meta name="description" content="Learn to drive with expert DVSA-approved instructors. Affordable automatic lessons, intensive courses, and refresher training in Northampton. Book today." data-id="element-1329" data-mp="e9k7lgeqv7ua" />
        <meta name="keywords" content="automatic driving lessons Northampton, driving instructor Northampton, intensive driving courses Northampton, refresher driving lessons Northampton, DVSA approved instructors, 10-hour driving lessons Northampton, automatic driving course deals Northampton" data-id="element-1330" data-mp="2z13yei8qrbex" />
      </Helmet>
      <Hero data-id="element-1331" data-mp="35fb9ecc2yn6y" />
      {/* Trust & Accreditation Strip */}
      <div className="bg-white py-4 border-b border-gray-200" data-id="element-1332" data-mp="30jvstcmoud6u">
        <div className="container mx-auto px-4" data-id="element-1333" data-mp="21gub1txhyk7">
          <p className="text-center text-gray-700 font-medium" data-id="element-1334" data-mp="205rb48b4uu5">
            DVSA Approved Instructors | ⭐⭐⭐⭐⭐ Rated by Students | Serving
            Northampton & Surrounding Areas
          </p>
        </div>
      </div>
      {/* Welcome/About Section */}
      <section className="py-12 bg-white" data-id="element-1335" data-mp="3k73d1r2iicsu">
        <div className="container mx-auto px-4" data-id="element-1336" data-mp="3k6ac56q8ihim">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1337" data-mp="2cti1jobxgidb">
            <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1338" data-mp="2cqvurqwv26w5">
              Welcome to <span className="text-burgundy-600" data-id="element-1339" data-mp="28ptsf17ndepy">N</span>orthampton{' '}
              <span className="text-burgundy-600" data-id="element-1340" data-mp="oa5idcooyc8l">D</span>riving{' '}
              <span className="text-burgundy-600" data-id="element-1341" data-mp="saxse85e0l5x">S</span>chool
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-1342" data-mp="s8v4purpj44d">
              Learning to drive doesn't need to be stressful. With modern
              automatic cars, friendly instructors, and flexible scheduling,
              we'll help you gain confidence from your very first lesson.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mt-10" data-id="element-1343" data-mp="16zkhh1ktgrac">
              <div className="bg-white shadow-md rounded-lg overflow-hidden p-2" data-id="element-1344" data-mp="1bxdkjlqtp56e">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2oyjszRjznB9bvy2zh5BXs/Automatic_car.png" alt="Modern automatic car used for driving lessons in Northampton" className="w-full h-40 object-cover rounded" data-id="element-1345" data-mp="1g1lebxc51bbh" />
                <div className="p-5" data-id="element-1346" data-mp="3ms192zliliux">
                  <p className="font-medium text-burgundy-800" data-id="element-1347" data-mp="3mt2o1f5niphx">
                    Automatic Cars Only
                  </p>
                </div>
              </div>
              <div className="bg-white shadow-md rounded-lg overflow-hidden p-2" data-id="element-1348" data-mp="oyq3n3iixvic">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jd12Jd7G1HzetPyKCwnF5A/Trsuted_driver.png" alt="DVSA-approved driving instructor teaching student in Northampton" className="w-full h-40 object-cover rounded" data-id="element-1349" data-mp="12xfzygxirr5n" />
                <div className="p-5" data-id="element-1350" data-mp="17v7ttghq5nch">
                  <p className="font-medium text-burgundy-800" data-id="element-1351" data-mp="17u6hz9svwwtp">
                    Patient, Qualified Instructors
                  </p>
                </div>
              </div>
              <div className="bg-white shadow-md rounded-lg overflow-hidden p-2" data-id="element-1352" data-mp="1hmlz64wcxhdj">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/p8ENDsD7c9AEgWWLAJNEei/first_time_pass.png" alt="Student celebrating after passing driving test first time in Northampton" className="w-full h-40 object-cover rounded" data-id="element-1353" data-mp="1vmwov4lxkpx4" />
                <div className="p-5" data-id="element-1354" data-mp="2f751g31599tv">
                  <p className="font-medium text-burgundy-800" data-id="element-1355" data-mp="20aebslh9vchg">
                    High First-time Pass Rates
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Recent Passes */}
      <SuccessStories data-id="element-1356" data-mp="1rghsdefhse5q" />
      <TrustBadges data-id="element-1357" data-mp="1rfznjterkrm7" />
      {/* Offer Banner with updated styling to match packages */}
      <section className="py-8" data-id="element-1358" data-mp="1wa3wgi7lb9px">
        <div className="container mx-auto px-4" data-id="element-1359" data-mp="1hk4zgirru4c1">
          <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8 text-center max-w-3xl mx-auto" data-id="element-1360" data-mp="1hlg38il7vc35">
            <h2 className="text-xl md:text-2xl font-bold mb-3" data-id="element-1361" data-mp="1mj9aley9ac50">
              Start Your Journey With Affordable Automatic Lessons
            </h2>
            <p className="text-gray-700 mb-5" data-id="element-1362" data-mp="1clbj8il3nz86">
              Start your journey with our affordable automatic driving lessons
              in Northampton — flexible hourly and package options available.
            </p>
            <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-1363" data-mp="1o29dzq57fz2u">
              Book Now
            </a>
          </div>
        </div>
      </section>
      {/* Standard Packages Section */}
      <section className="py-12 bg-gray-50" data-id="element-1364" data-mp="158vsebndt4zw">
        <div className="container mx-auto px-4" data-id="element-1365" data-mp="10au7dl6eavls">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-2 text-burgundy-600" data-id="element-1366" data-mp="109j3llcy9nuo">
            Standard Lessons
          </h2>
          <h3 className="text-xl md:text-2xl font-bold text-center mb-2" data-id="element-1367" data-mp="qdzbzb5f5bbq">
            Learn at Your Own Pace
          </h3>
          <p className="text-gray-600 text-center mb-8" data-id="element-1368" data-mp="md5q0nbje6lh">
            Pick a package that suits your schedule.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1369" data-mp="2xyy6g3q7c1oa">
            {standardPackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1370" data-mp="322no098glizt" data-mpi={index} />)}
          </div>
          <div className="text-center mt-8" data-id="element-1371" data-mp="370pbr7gty6hm">
            <Link to="/standard-lessons" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-flex items-center transition-colors" data-id="element-1372" data-mp="3bzinauck3nf5">
              View All Standard Lessons{' '}
              <ArrowRight size={16} className="ml-2" data-id="element-1373" data-mp="2j7yymux6xh5r" />
            </Link>
            <div className="max-w-2xl mx-auto mt-8 bg-white p-6 rounded-lg shadow-md" data-id="element-1374" data-mp="2o7tsn7c9imv1">
              <h4 className="font-bold text-lg mb-2" data-id="element-1375" data-mp="2t0wlfd97tsa6">Standard Lessons</h4>
              <p className="mb-4" data-id="element-1376" data-mp="1vliqhs90cdw4">
                Learn at your own pace with flexible scheduling. Perfect for
                beginners or those who prefer a gradual learning approach.
              </p>
              <ul className="space-y-2" data-id="element-1377" data-mp="2brfmbazr9hcm">
                <li className="flex items-start" data-id="element-1378" data-mp="2bsqqvd10yt4s">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1379" data-mp="2goxzxeopwkqy" />
                  <span data-id="element-1380" data-mp="2lmr4626gn4ol">Flexible scheduling</span>
                </li>
                <li className="flex items-start" data-id="element-1381" data-mp="2qmlvg6u5dwa6">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1382" data-mp="1t06er79jp2no" />
                  <span data-id="element-1383" data-mp="1y013p59rfi63">Personalised learning</span>
                </li>
                <li className="flex items-start" data-id="element-1384" data-mp="22xsu1uuraw86">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1385" data-mp="22x17f9j508u1" />
                  <span data-id="element-1386" data-mp="1aa6tkvgts7pj">Discounted packages available</span>
                </li>
                <li className="flex items-start" data-id="element-1387" data-mp="1f8rqom0s6b9r">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1388" data-mp="1f76yv45up6fl" />
                  <span data-id="element-1389" data-mp="3ohg1el6nj25x">Our 10-hour package is most popular</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Intensive Courses Section */}
      <section className="py-12 bg-white" data-id="element-1390" data-mp="3ejifi4c9lhgh">
        <div className="container mx-auto px-4" data-id="element-1391" data-mp="3eigvhad9tkmm">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-2 text-burgundy-600" data-id="element-1392" data-mp="39jx58xrn9mog">
            Intensive Lessons
          </h2>
          <h3 className="text-xl md:text-2xl font-bold text-center mb-2" data-id="element-1393" data-mp="34sdzr2erlskl">
            Pass in Weeks, Not Months
          </h3>
          <p className="text-gray-600 text-center mb-8" data-id="element-1394" data-mp="30s3kt08zvrtl">
            Fast-track courses designed for learners in a hurry.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1395" data-mp="2qtec9y2znjq0">
            {intensivePackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1396" data-mp="2lvw07ytocods" data-mpi={index} />)}
          </div>
          <div className="text-center mt-8" data-id="element-1397" data-mp="2c6pec0odxelq">
            <Link to="/intensive-lessons" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-flex items-center transition-colors" data-id="element-1398" data-mp="2c91uq9ehvgwo">
              Explore Intensive Lessons{' '}
              <ArrowRight size={16} className="ml-2" data-id="element-1399" data-mp="278nlio15q0x2" />
            </Link>
            <div className="max-w-2xl mx-auto mt-8 bg-white p-6 rounded-lg shadow-md" data-id="element-1400" data-mp="2uwyhpdvwrcf0">
              <h4 className="font-bold text-lg mb-2" data-id="element-1401" data-mp="2zwa1kvrkmy0t">Intensive Courses</h4>
              <p className="mb-4" data-id="element-1402" data-mp="2zynw93ica87u">
                Fast-track your learning with our intensive courses. Perfect for
                those who want to pass their test quickly.
              </p>
              <ul className="space-y-2" data-id="element-1403" data-mp="2q4nh08tcfmle">
                <li className="flex items-start" data-id="element-1404" data-mp="3dvsuwifq44t2">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1405" data-mp="3dv189x43thex" />
                  <span data-id="element-1406" data-mp="177k38vvdu4wg">Pass in weeks, not months</span>
                </li>
                <li className="flex items-start" data-id="element-1407" data-mp="128z30wg4rl80">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1408" data-mp="1287l2ofghm07" />
                  <span data-id="element-1409" data-mp="1byselxg9w0c9">Concentrated learning</span>
                </li>
                <li className="flex items-start" data-id="element-1410" data-mp="1bzk9f621pu1h">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1411" data-mp="o8el02i1htfk" />
                  <span data-id="element-1412" data-mp="jby0dia1tx78">Significant cost savings</span>
                </li>
                <li className="flex items-start" data-id="element-1413" data-mp="y85fi46lo8fn">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1414" data-mp="t8aqy7aaruxr" />
                  <span data-id="element-1415" data-mp="29l7uwvwyqry8">Courses from 10 to 40 hours</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Additional Lessons Section */}
      <section className="py-12 bg-gray-50" data-id="element-1416" data-mp="e7nne9507575">
        <div className="container mx-auto px-4" data-id="element-1417" data-mp="j5ffb35nerbc">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-2 text-burgundy-600" data-id="element-1418" data-mp="j68d3emmq6hc">
            Additional Lessons
          </h2>
          <h3 className="text-xl md:text-2xl font-bold text-center mb-2" data-id="element-1419" data-mp="n9dgdjejac71">
            Specialised Driving Support
          </h3>
          <p className="text-gray-600 text-center mb-8" data-id="element-1420" data-mp="x5q6y8es89xk">
            Additional lessons to enhance your driving skills and confidence.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1421" data-mp="122gnewui17ji">
            {additionalPackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1422" data-mp="1awd59zgmrxt4" data-mpi={index} />)}
          </div>
          <div className="text-center mt-8" data-id="element-1423" data-mp="1ayfsycub9euo">
            <Link to="/additional-lessons" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-flex items-center transition-colors" data-id="element-1424" data-mp="1fwr4qt461zfj">
              View All Additional Lessons{' '}
              <ArrowRight size={16} className="ml-2" data-id="element-1425" data-mp="1pzwgflkag6rp" />
            </Link>
            <div className="max-w-2xl mx-auto mt-8 bg-white p-6 rounded-lg shadow-md" data-id="element-1426" data-mp="1q1pp16egp12c">
              <h4 className="font-bold text-lg mb-2" data-id="element-1427" data-mp="1l0tkcqmadavv">Additional Lessons</h4>
              <p className="mb-4" data-id="element-1428" data-mp="1h09odqdg8dbb">
                Specialised lessons to enhance specific skills or build
                confidence in particular areas of driving.
              </p>
              <ul className="space-y-2" data-id="element-1429" data-mp="28pumxx8ftrt8">
                <li className="flex items-start" data-id="element-1430" data-mp="28s7e91035eiy">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1431" data-mp="23ymdj173y6g2" />
                  <span data-id="element-1432" data-mp="1zvq1jtc2p8l3">Refresher driving lessons</span>
                </li>
                <li className="flex items-start" data-id="element-1433" data-mp="2wgi5rdjw61uk">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1434" data-mp="2rp8l6rd79opj" />
                  <span data-id="element-1435" data-mp="psremzt8x2bo">Motorway driving lessons</span>
                </li>
                <li className="flex items-start" data-id="element-1436" data-mp="uqsw5gb0wtl1">
                  <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1437" data-mp="usm02nu94zpc" />
                  <span data-id="element-1438" data-mp="kzy6e1ykjbuu">Tailored to your specific needs</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Learn To Drive With Us section */}
      <LearnToDriveWithUs data-id="element-1439" data-mp="c1306pviy1rj" />
      {/* Call to Action */}
      <section className="py-16 bg-burgundy-700 text-white" data-id="element-1440" data-mp="3t86itkey0how">
        <div className="container mx-auto px-4 text-center" data-id="element-1441" data-mp="3t9pzhc4igur7">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1442" data-mp="21c62pavlorz">
            Ready to Get Behind the Wheel? 🚦
          </h2>
          <p className="mb-8 max-w-2xl mx-auto" data-id="element-1443" data-mp="1ri3h1yyoq86c">
            Book your driving lessons today and take the first step towards
            driving independence.
          </p>
          <div className="max-w-3xl mx-auto mb-8" data-id="element-1444" data-mp="3gxe7g5srn70q">
            <BeforeYouBook data-id="element-1445" data-mp="3gy77knx7yy9w" />
          </div>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-white text-burgundy-700 hover:bg-gray-100 px-8 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-1446" data-mp="3bzcnlinin3o7">
            Book Now
          </a>
        </div>
      </section>
    </div>;
};
export default HomePage;